import { PORTAL_ACCENT, PORTAL_ACCENT_MUTED, PORTAL_ACCENT_SOFT } from './portalTheme';

/** Build switch styles from portal tokens (supports future per-mode overrides). */
export const getBrandSwitchStyles = (tokens) => ({
  '&.Mui-disabled': {
    opacity: 1,
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: tokens.accent,
    '&:hover': {
      backgroundColor: `${tokens.accent}14`,
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: tokens.accent,
    opacity: 1,
  },
  '& .MuiSwitch-switchBase.Mui-disabled': {
    opacity: 1,
    color: '#BDBDBD',
    '& + .MuiSwitch-track': {
      backgroundColor: '#E0E0E0',
      opacity: 1,
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled': {
    color: tokens.accentMuted,
    '& + .MuiSwitch-track': {
      backgroundColor: tokens.accentSoft,
      opacity: 1,
    },
  },
  '& .MuiSwitch-switchBase.Mui-disabled:hover': {
    backgroundColor: 'transparent',
  },
});

/** Default light-mode switch styles. Prefer getBrandSwitchStyles(theme.portal) in themed components. */
export const brandSwitchStyles = getBrandSwitchStyles({
  accent: PORTAL_ACCENT,
  accentMuted: PORTAL_ACCENT_MUTED,
  accentSoft: PORTAL_ACCENT_SOFT,
});

/** @deprecated Use PORTAL_ACCENT from portalTheme */
export const BRAND_ORANGE = PORTAL_ACCENT;
